import * as React from "react";

import "./component-editor.scss";

import {isPickPack} from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {oMapToArr}  from "@Common/utils/objects";

import {IconTooltip} from "@Xpresso/common/tool-tip";

import {DeliveryMethods} from "../modules/delivery-methods/delivery-methods";
import {ComponentInfo}   from "../modules/item-description/component-info";
import {lineItems}       from "../modules/line-items/line-items";
import {PaperType}       from "../modules/paper-type/paper-type";
import {PickPack}        from "../modules/pick-pack/ui/pick-pack";
import {YardSign}        from "../modules/yard-sign/ui/yard-sign";

export const ComponentEditor = (
    {
        componentState, redirectAction, templateOptions, templateBack, templateBackId,
        itemOptions, item, itemComponentState, isInternalUser
    }
) => (
    <div className="component-editor-3f6">
        {templateOptions && templateBack && <IconTooltip/>}

        {ComponentInfo({
            className: "section",
            templateOptions,
            isPickPack: isPickPack(templateOptions),
            component: componentState.value,
            isInternalUser,
        })}

        {DeliveryMethods({
            componentState,
            templateOptions,
            item,
            defaultMethod: item?.selections?.distributionType ?? "shipping",
        })}

        {lineItems({
            componentState,
            templateOptions,
        })}

        {PaperType({
            componentState,
            templateOptions,
            className: "section",
            templateBack,
            templateBackId,
        })}

        {itemOptions.ui.pickPack && PickPack({
            ...itemOptions.ui.pickPack,
            className: "section",
        })}

        {itemOptions.ui.yardSign && YardSign({
            ...itemOptions.ui.yardSign,
            className: "section",
        })}
        {!isPickPack(templateOptions) && (
            <div className="action-btns">
                <button
                    className="customize"
                    disabled={itemBackSelectionRequiresAttention(itemComponentState.value)}
                    onClick={() => redirectAction({forceCustomize: true, templateOptions})}
                    xd-qa-type="button"
                    xd-qa-name="Change Customize"
                >
                    {componentState.value?.itemThumbnails?.length > 0 ? (
                        "Change Customization"
                        ) : (
                        "Customize"
                    )}
                </button>
            </div>
        )}

    </div>
);

//need to prevent order saves while in back selection.
const itemBackSelectionRequiresAttention = (item) => {
    console.log("item", item);
    return oMapToArr(item)
        .filter((component) => component.selections?.quantity > 0)
        .some((component) => (!!component?.changeBackOverride)
    )
}